module.exports = {"340871001":"菱北街道","340871100":"老峰镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340871.json
// module id = 1207
// module chunks = 0